// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const FacetsConfig = (i18n: any) => function(config: any) {
   let facets: any[] = []

   if (config.facets != null) {
      facets = _(config.facets.facets2 || []).map((f: any) => ({
         name: f["Name"],
         label: i18n.translate(f["Label"] || f["Name"]),
         type: f["Type"] === "Range" ? 'daterange' : f["Type"] === "DaysOld" ? 'daysold' : 'list',
         collapsed: !(config.facets.expanded_facets || []).includes(f["Name"]),
         moreLoaded: false,
         sortMethod: "-count"
      }))
   }
   return facets
}

FacetsConfig.$inject = ['translationService']

angular.module('summonApp.factories.configs')
   .factory('facetsConfig', FacetsConfig)
